

<template>
  <div class="table-borderless">
    <div v-for="(group, i) in items" dense :key="'group-' + i">
      <div v-if="group.show">
        <base-card class="mb-5" v-if="cards">
          <EstimateGroupTable v-bind="$attrs" class="mx-2 pb-3" :group="group" />
        </base-card>
        <div v-else>
          <EstimateGroupTable v-bind="$attrs" :group="group" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EstimateGroupTable from "./EstimateGroupTable";
import BaseCard from "../auto/BaseCard";

export default {
  components: {
    BaseCard,
    EstimateGroupTable,
  },

  props: {
    all: {
      type: Boolean,
      default: false,
    },
    cards: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    items() {
      return this.$store.state.pricing.items.map((el) => {
        return { ...el, show: this.show(el) };
      });
    },
  },

  methods: {
    show(group) {
      if (group.items.length === 0) return false;

      if (this.all) return true;

      if (group.steps.length === 0) return true;

      if (group.steps.includes(this.$store.state.step)) return true;

      return false;
    },
  },
};
</script>
